<template>
    <div class="custom-panel">
        <div class="custom-panel-title" v-if="!hideTitle">
            <div class="text">{{ title }}</div>
            <div class="more" v-if="!hideMore" @click="moreClickHandle">
                {{ moreText }}
            </div>
        </div>
        <div class="custom-panel-content" :style="contentStyle">
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        height: {
            type: Number
        },
        hideMore: {
            type: Boolean,
            default: false
        },
        hideTitle: {
            type: Boolean,
            default: false
        },
        moreText: {
            type: String,
            default: '查看全部'
        }
    },

    data() {
        return {};
    },

    computed: {
        contentStyle() {
            return this.height
                ? {
                      height: this.hideTitle ? `${this.height - 8}px` : `${this.height - 36 - 32}px`
                  }
                : {};
        }
    },

    methods: {
        moreClickHandle() {
            this.$emit('moreClick');
        }
    }
};
</script>

<style lang="scss" scoped>
$primary-color: #005299;

.custom-panel {
    font-family: PingFangSC-Semibold;
    padding: 0 24px 24px;
    border-radius: 4px;
    background: #ffffff;
    box-shadow: 0px 2px 8px 1px rgba(65, 101, 173, 0.16);
    box-sizing: border-box;

    &-title {
        height: 48px;
        margin-bottom: 12px;
        border-bottom: 1px dashed #d3d3d3;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;

        &::before {
            content: '';
            width: 28px;
            height: 4px;
            position: absolute;
            top: calc(100% - 2px);
            background: $primary-color;
        }

        > .text {
            font-size: 20px;
            color: $primary-color;
            font-weight: 600;
        }

        > .more {
            font-size: 14px;
            color: #666666;
            cursor: pointer;

            &::after {
                content: '';
                display: inline-block;
                width: 16px;
                height: 16px;
                transform: translateY(3px);
                background: url(./img/icon-right.svg) no-repeat center center / contain;
            }
        }
    }

    &-content {
        overflow: auto;
    }
}
</style>
